import React from 'react';

function BookDetail() {
  return <h1>abde</h1>;
}

export default BookDetail;
